export default __webpack_public_path__ + "static/media/loading.9ff10b43.svg";